import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './base-query-with-reauth';

export const baseApi = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Conversation', 'Messages', 'AiCredits'],
    endpoints: () => ({}),
});
